import React from "react";
import YesNo from "./YesNo";
import Choice from "./Choice";
import Range from "./Range";
import PreferredAgeRange from "./PreferredAgeRange";
import Text from "./Text";

const QuestionField = ({
  question,
  onChange,
  hideLabel,
  placeholder,
  commitOnChange,
  multiHint,
}) => {
  if (!question) return null;

  const shared = {
    question,
    onChange,
    hideLabel,
    placeholder,
    commitOnChange,
    multiHint,
  };

  if (question.variant === "preferredAge") {
    return <PreferredAgeRange {...shared} />;
  }
  if (question.questionType === "yesno") {
    return <YesNo {...shared} />;
  }
  if (
    question.questionType === "choice" ||
    question.questionType === "multipleChoice"
  ) {
    return <Choice {...shared} />;
  }
  if (question.questionType === "related" && question.choices.length > 0) {
    return <Choice {...shared} />;
  }
  if (question.questionType === "related" && question.choices.length === 0) {
    return <YesNo {...shared} />;
  }
  if (question.questionType === "range") {
    return <Range {...shared} />;
  }
  if (question.questionType === "text") {
    return <Text {...shared} />;
  }
  return null;
};

const isMultiSelect = (question) =>
  question.questionType === "multipleChoice" ||
  (question.questionType === "related" &&
    question.matchingCriteria === "multiple");

export const isAutoAdvanceQuestion = (question) => {
  if (!question) return false;
  if (isMultiSelect(question)) return false;
  return question.questionType !== "text";
};

export default QuestionField;
